export const API = {

    GET_CRN: "/Dispatch/getCRN",
    GET_CRN_DETAILS: "/Dispatch/getCRNWithItems",
    GET_TRIP_CATEGORY: "/Dispatch/get_trip_category",
    CREATE_CRN: "/Dispatch/updateCRN",
    GET_RRN: "/Dispatch/getRRN",
    GET_RRN_DETAILS: "/Dispatch/getRRNWithItems",
}